import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentMethods } from 'src/models/DTO/payMethods/paymentMethods';
import { Config } from '../../../infrastructure/config';

@Injectable({
  providedIn: 'root'
})
export class PayMethodsService {

  private payMethodsURL: string = Config.api + "payment-methods";
  private storedPayMethodsURL: string = Config.api + "payment-methods/user-stored/";


  constructor(
    private httpClient: HttpClient
  ) { }

  public getPaymentMethods() {
    return this.httpClient.get<PaymentMethods>(this.payMethodsURL);
  }

  public getStoredPaymentMethodsForUser(type: string) {
    return this.httpClient.get(this.storedPayMethodsURL + type);
  }
}
